import { render } from "./calculate.vue?vue&type=template&id=4ea314fc&scoped=true"
import script from "./calculate.vue?vue&type=script&lang=js"
export * from "./calculate.vue?vue&type=script&lang=js"

import "./calculate.vue?vue&type=style&index=0&id=4ea314fc&scoped=true&lang=scss"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea314fc"]])

export default __exports__